module.exports = __webpack_public_path__ + "static/media/galerija_2016 (12).cae1fc59.jpg";